import { createReducer, on } from "@ngrx/store";
import { WireInfo } from "../../create-request/models/wire/WireInfo";
import { StandingAuthConfirmationPageActions, StandingAuthReviewPageActions, StandingAuthWireActions, StandingAuthFormActions } from "../actions";
import { TransactionFormActions } from "../../create-request/actions";
import { TaxAmountAndPercentageFormatter } from "../../shared/utilities/TaxAmountAndPercentageFormatter";
import { EAuthModelCustomer } from "../../create-request/models/internal-transfer/EAuthModelCustomer";
import { AccountInfoActions } from "../../account-info-header/actions";
import { AccountInfoResponse } from "../../account-info-header/models";
import {InitReleaseActions} from "../../initiate-and-release/actions";
import {yesNo} from "../../shared/utilities/Constants";

export const standingAuthWireInfoKey = 'wireInfo';

export interface State extends WireInfo { }

export const initialWireInfoState: State = {
    receivingBankDetails: {
        recBankAba: '',
        recBankName1: '',
        recBankName2: '',
        recBankAddress1: '',
        recBankAddress2: '',
        recBankCountry: '',
        bankPhoneArea: '',
        bankPhoneNum1: '',
        bankPhoneNum2: '',
        intermediaryAccount: '',
        intermediaryName1: '',
        intermediaryName2: '',
        intermediaryAddress1: '',
        intermediaryAddress2: '',
        interPhoneArea: '',
        interPhoneNum1: '',
        interPhoneNum2: '',
        interPhoneExt: '',
    },
    receivingBankDetailsIso: {
      recBankName: '',
      recBankAddress: {
        department: '',
        streetName: '',
        buildingNumber: '',
        buildingName: '',
        floor: '',
        room: '',
        postCode: '',
        townName: '',
        townLocationName: '',
        districtName: '',
        countrySubDivision: '',
        country: '',
        concatenatedAddress: ''
      },
      recBankPhone: '',
      recBankAba: '',
      intermediaryName: '',
      intermediaryAccount: '',
      intermediaryAddress: {
        department: '',
        streetName: '',
        buildingNumber: '',
        buildingName: '',
        floor: '',
        room: '',
        postCode: '',
        townName: '',
        townLocationName: '',
        districtName: '',
        countrySubDivision: '',
        country: '',
        concatenatedAddress: ''
      },
      intermediaryPhone: ''
    },
    receivingBankAba: '',
    receivingBankClearingSysId: '',
    abaStatusCode: '',
    abaMessageFields: {
        errorList: [],
        warningList: [],
        atsSystemErrors: [],
    },
    receivingAccountHolder: {
        accountHolderName1: '',
        accountHolderName2: '',
        accountHolderAddress1: '',
        accountHolderAddress2: '',
        countryCode: ''
    },
    receivingAccountHolderIso: {
      name: '',
      accountHolderStreetNumber: '',
      accountHolderStreetName: '',
      accountHolderApartmentSuiteEtc: '',
      countryCode: '',
      receivingBankCity: '',
      receivingBankState: '',
      zipCode: '',
      department: '',
      buildingName: '',
      floor: '',
      townLocationName: '',
      district: '',
      phone: ''
    },
    withholdFedTax: false,
    withholdStateTax: false,
    stateCd: '',
    fedTaxPercent: '',
    fedTaxAmount: '',
    inputIraFields: {
        stateTaxPercent: '',
        fedTaxPercent: '',
    },
    stateTaxPercent: '',
    stateTaxAmount: '',
    stateHasTaxes: false,
    stateTypeIndicator: '',
    availableCashMMF: '',
    availableCashMargin: '',
    distributionReasonDescription: '',
    distributionReason: {
        code: '',
        subCode: '',
        description: '',
        isTaxExempt: false,
    },
    distributionReasonMap: [],
    pendReasons: [],
    countryList: [],
    processDateFields: {
        isExtendedProcessingWindow: false,
        useExtendedProcessDates: false,
        standardProcessDates: [],
        extendedProcessDates: [],
    },
    wireFee: '',
    eauthAccess: false,
    clientAuthorizationNeeded: false,
    isTransactionFromSLOAOrSLOA: false,
    isBsloaTransaction: false,
    eAuthModel: {
        isTransactionFromSLOA: false,
        eauthSelected: false,
        isTransactionFromSLOAOrSLOA: false,
        numberOfAuthRequired: 0,
        eauthEligibilityServiceSLOAError: false,
        eauthEligibilityServiceDown: false,
        eauthEligibilityServiceSLOAErrorMsg: '',
        isOrgAccount: false,
        accountRestricted: false,
        orgOrEduSavingsAccount: false,
        custAcctAuthorizationsListEmpty: false,
        eauthInd: false,
        eauthSLOAInd: false,
        allAccountHolderIneligible: false,
        numOfIneligibleCust: 0,
        eauthEligibilityServiceDownErrorMsg: '',
        custAcctAuthorizationsList: {
            allAccountHoldersIneligible: false,
            numOfIneligibleCust: 0,
            numOfNotWebEnabledCust: 0,
            totalNumOfAccountHolders: 0,
            eauthInd: false,
            eAuthCustomerList: [],
        },
        custAcctSLOAAuthorizationsList: {
            allAccountHoldersIneligible: false,
            numOfIneligibleCust: 0,
            numOfNotWebEnabledCust: 0,
            totalNumOfAccountHolders: 0,
            eauthInd: false,
            eAuthCustomerList: [],
        },
        transactionType: '',
        submitButtonsDisable: '',
        txnType: '',
    },
    toDetails: {
        accountNumber: '',
        beneficiaryName1: '',
        beneficiaryName2: '',
        beneficiaryAddress1: '',
        beneficiaryAddress2: '',
        beneficiaryCountry: '',
        receivingBankAba: '',
        receivingBankName: [],
        receivingBankAddress: [],
        receivingBankCountry: '',
        receivingBankPhone: '',
        receivingBankType: '',
        intermediaryFields: {
            accountId: '',
            accountIdType: '',
            name1: '',
            name2: '',
            address1: '',
            address2: '',
            phoneFull: '',
            countryName: '',
        },
        creditToFields: {
            accountId: '',
            accountIdType: '',
            name1: '',
            name2: '',
            address1: '',
            address2: '',
            phoneFull: '',
            countryName: '',
        },
        canDisplayIntermediaryPhone: false,
        canDisplayReceivingBankPhone: false,
    },
    loading: false,
    error: '',
    hasError: false,
    detailsCallSucceeded: false,
    detailsCallFailed: false,
    inputCallV3Finished: false,
    inputCallV3Failed: false,
    verifyV3CallFinished: false,
    OneTimeAndSloaWiresVerifyV3Finished: false,
    OneTimeAndSloaWiresVerifyV3Failed: false,
    standingAuthCallSucceeded: false,
    withdrawalAmount: '',
    wireAmount: '',
    canDisplayCreditToInfo: false,
    creditTo: {
        insitutionName1: '',
        insitutionName2: '',
        institutionAddress: '',
        institutionAddressContd: '',
        insitutionAccountNumber: '',
        institutionCountry: '',
        institutionPhoneNumber: ''
    },
    caseId: '',
    caseKey: '',
    transferId: '',
    isFedWire: true,
    requestedDate: '',
    missingThirdPartyAddress: false,
    missingIntermediaryAddress: false,
    hasNDFALPFA: false,
    warningsList: [],
    isPendingOnlyForCTWE: false,
    isSubmitAndCreate: false,
    submitAndCreateToggledOn: false,
    hasCustodianRole: false,
    nickname: '',
    cashieringIraAgreementText: '',
    foreignCurrencyFields: {
      currencyAmount: '',
      currencyType: '',
      exchangeRate: ''
  },
  authResponse: {
    draftId: '',
    pendForRelease: false,
    canRelease: false,
    pendForReleaseReason: ''
  },
  attestationSubmittedBy: {
    firstName: '',
    lastName: ''
  },
  revalidation: {
    status: '',
    errors: [],
    fieldsUpdated: []
  },
  regShortName: '',
  isISOCompliant: false,
  isEscrow: false,
  transmissionNotes: '',
  isIrsAba: false,
  taxRemittance: {
      taxId: '',
      taxMonthCode: '',
      taxTypeCode: '',
      taxYear: '',
      additionalInfo: ''
  }

}

export const standingAuthWireReducer = createReducer(
  initialWireInfoState,
  on(
    StandingAuthReviewPageActions.cancelClicked,
    StandingAuthConfirmationPageActions.createNewStandingAuthClicked,
    () => {
      return initialWireInfoState;
    }
  ),
   on(StandingAuthWireActions.clearStandingAuthWireAuthResponse, (state) => {
    return {
      ...state,
      authResponse: initialWireInfoState.authResponse,
      hasError: false
    };
  }),
  on(StandingAuthWireActions.callWireInputV3,() => {
    return {
      ...initialWireInfoState,
      loading: true,
    };
  }),
  on(StandingAuthWireActions.wireInputCallSuccessfulV3, (state, response) => {
    return {
      ...state,
      loading: false,
      error: '',
      hasError: false,
      inputCallV3Finished: true,
      receivingAccountHolder: {
        accountHolderName1:
          response.beneficiaryFields.mailingDetails?.namePartOne?.trim(),
        accountHolderName2:
          response.beneficiaryFields.mailingDetails?.namePartTwo?.trim(),
        accountHolderAddress1:
          response.beneficiaryFields.mailingDetails?.addressLineOne?.trim(),
        accountHolderAddress2:
          response.beneficiaryFields.mailingDetails?.addressLineTwo?.trim(),
        countryCode: response.beneficiaryFields.mailingDetails?.countryCode,
      },
      receivingAccountHolderIso: {
        name: response.sloaInfo != null ? response.sloaInfo?.isoParties[0].name : response.accountNameAddressV2Response?.name,
        accountHolderStreetNumber: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.buildingNumber?.trim() : response.accountNameAddressV2Response?.postalAddress?.buildingNumber,
        accountHolderStreetName: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.streetName?.trim() : response.accountNameAddressV2Response?.postalAddress?.streetName,
        accountHolderApartmentSuiteEtc: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.room?.trim() : response.accountNameAddressV2Response?.postalAddress?.room,
        countryCode: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.country?.trim() : response.accountNameAddressV2Response?.postalAddress?.country,
        receivingBankCity: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.townName?.trim() : response.accountNameAddressV2Response?.postalAddress?.townName,
        receivingBankState: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.countrySubDivision?.trim() : response.accountNameAddressV2Response?.postalAddress?.countrySubDivision,
        zipCode: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.postCode?.trim() : response.accountNameAddressV2Response?.postalAddress?.postCode,
        department: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.department?.trim() : response.accountNameAddressV2Response?.postalAddress?.department,
        buildingName: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.buildingName?.trim() : response.accountNameAddressV2Response?.postalAddress?.buildingName,
        floor: response.sloaInfo != null ? response.sloaInfo?.isoParties[0]?.postalAddress?.floor?.trim() : response.accountNameAddressV2Response?.postalAddress?.floor,
        townLocationName: response.sloaInfo!= null ? response.sloaInfo?.isoParties[0]?.postalAddress?.townLocationName?.trim() : response.accountNameAddressV2Response?.postalAddress?.townLocationName,
        district: response.sloaInfo!= null ? response.sloaInfo?.isoParties[0]?.postalAddress?.districtName?.trim() : response.accountNameAddressV2Response?.postalAddress?.districtName,
        phone: response.accountNameAddressV2Response?.phone ? response.accountNameAddressV2Response?.phone[0].number.trim() : ''
      },
      countryList: response.wireResources?.countryList,
      withholdFedTax: response.accountInfo.taxInfo?.withholdFedTaxes,
      withholdStateTax: response.accountInfo.taxInfo?.withholdStateTaxes,
      stateCd: response.accountInfo.taxInfo?.stateCd,
      fedTaxPercent: response.accountInfo.taxInfo?.fedTaxPercent?.toString(),
      inputIraFields: {
        stateTaxPercent:
          response.accountInfo.taxInfo?.stateTaxPercent?.toString(),
        fedTaxPercent: response.accountInfo.taxInfo?.fedTaxPercent?.toString(),
      },
      stateTaxPercent: response.accountInfo.taxInfo?.stateTaxPercent?.toString(),
      stateHasTaxes: response.accountInfo.taxInfo?.stateHasTaxes,
      stateTypeIndicator: response.accountInfo.taxInfo?.stateTypeInd,
      availableCashMMF: response.accountInfo.cashInfo?.cusAvailableCashMMF,
      availableCashMargin: response.accountInfo.cashInfo?.cusAvailableOnMargin,
      distributionReasonMap:
        response.accountInfo.taxInfo?.distributionReasonsList ?? [],
      canDisplayCreditToInfo: response.sloaInfo?.isoFinancialInstitutions?.length > 2,
      creditTo: {
        insitutionName1:
          response.sloaInfo?.creditTo?.mailingDetails?.namePartOne,
        insitutionName2:
          response.sloaInfo?.creditTo?.mailingDetails?.namePartTwo,
        institutionAddress:
          response.sloaInfo?.creditTo?.mailingDetails?.addressLineOne,
        institutionAddressContd:
          response.sloaInfo?.creditTo?.mailingDetails?.addressLineTwo,
        insitutionAccountNumber: response.sloaInfo?.creditTo?.id,
        institutionCountry:
          response.sloaInfo?.creditTo?.mailingDetails?.countryName,
        institutionPhoneNumber:
          response.sloaInfo?.creditTo?.mailingDetails?.phoneNumber,
      },
      isFedWire: response.sloaInfo?.isFedWire ?? true,
      missingThirdPartyAddress:
        response.sloaInfo?.beneficiary?.mailingDetails?.addressLineOne?.trim() ===
          '' ||
        response.sloaInfo?.beneficiary?.mailingDetails?.countryCode?.trim() ===
          '',
      hasNDFALPFA: response.accountInfo.restrictedByNdfaOrLpfa,
      isIrsAba: response.sloaInfo?.isIrsAba,
      taxRemittance : response.sloaInfo?.taxRemittance,
    };
  }),
  
  on(StandingAuthWireActions.wireInputFailedV3, (state, err) => {
    return {
      ...state,
      loading: false,
      error: err.message,
      hasError: true,
    };
  }),
  on(StandingAuthWireActions.wireDetailsCallLoading, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(StandingAuthWireActions.callWireDetails, (state) => {
    return {
      ...state,
      abaStatusCode: '',
      receivingBankDetails: {
        recBankAba: '',
        recBankName1: '',
        recBankName2: '',
        recBankAddress1: '',
        recBankAddress2: '',
        recBankCountry: '',
        bankPhoneArea: '',
        bankPhoneNum1: '',
        bankPhoneNum2: '',
        intermediaryAccount: '',
        intermediaryName1: '',
        intermediaryName2: '',
        intermediaryAddress1: '',
        intermediaryAddress2: '',
        interPhoneArea: '',
        interPhoneNum1: '',
        interPhoneNum2: '',
        interPhoneExt: '',
      },
      receivingBankAba: '',
      abaMessageFields: {
        errorList: [],
        warningList: [],
        atsSystemErrors: [],
      },
      detailsCallSucceeded: false,
      detailsCallFailed: false,
      loading: true,
      error: '',
      hasError: false,
      isIrsAba: false
    };
  }),
  on(StandingAuthWireActions.wireDetailsCallSuccessful, (state, response) => {
    const receivingBankName = (response.receivingBankDetails.recBankName1 !== null && response.receivingBankDetails.recBankName1 !== '') ? response.receivingBankDetails.recBankName1 : response.receivingBankDetailsIso.recBankName;
    const receivingBankAddress = (response.receivingBankDetails.recBankAddress1 !== null && response.receivingBankDetails.recBankAddress1 !== '') ? response.receivingBankDetails.recBankAddress1 : response.receivingBankDetailsIso.recBankAddress.townName + " " + response.receivingBankDetailsIso.recBankAddress.countrySubDivision;
    const receivingBankCountry = (response.receivingBankDetails.recBankCountry !== null && response.receivingBankDetails.recBankCountry !=='') ? response.receivingBankDetails.recBankCountry : response.receivingBankDetailsIso.recBankAddress.country;
    return {
      ...state,
      abaStatusCode: response.abaStatusCode,
      receivingBankDetails: {
        recBankAba: response.receivingBankDetails.recBankAba,
        recBankName1: receivingBankName,
        recBankName2: response.receivingBankDetails.recBankName2,
        recBankAddress1: receivingBankAddress,
        recBankAddress2: response.receivingBankDetails.recBankAddress2,
        recBankCountry: receivingBankCountry,
        bankPhoneArea: response.receivingBankDetails.bankPhoneArea,
        bankPhoneNum1: response.receivingBankDetails.bankPhoneNum1,
        bankPhoneNum2: response.receivingBankDetails.bankPhoneNum2,
        intermediaryAccount: response.receivingBankDetails.intermediaryAccount,
        intermediaryName1: response.receivingBankDetails.intermediaryName1,
        intermediaryName2: response.receivingBankDetails.intermediaryName2,
        intermediaryAddress1:
          response.receivingBankDetails.intermediaryAddress1,
        intermediaryAddress2:
          response.receivingBankDetails.intermediaryAddress2,
        interPhoneArea: response.receivingBankDetails.interPhoneArea,
        interPhoneNum1: response.receivingBankDetails.interPhoneNum1,
        interPhoneNum2: response.receivingBankDetails.interPhoneNum2,
        interPhoneExt: response.receivingBankDetails.interPhoneExt,
      },
      receivingBankDetailsIso: {
        recBankAba: response.receivingBankDetailsIso.recBankAba,
        recBankName: response.receivingBankDetailsIso.recBankName,
        recBankAddress: {
          townName: response.receivingBankDetailsIso.recBankAddress.townName,
          department: "",
          streetName: "",
          buildingNumber: "",
          buildingName: "",
          floor: "",
          room: "",
          postCode: "",
          townLocationName: "",
          districtName: "",
          countrySubDivision: response.receivingBankDetailsIso.recBankAddress.countrySubDivision,
          country: response.receivingBankDetailsIso.recBankAddress.country,
          concatenatedAddress: ""
        },
        intermediaryAccount: response.receivingBankDetailsIso.intermediaryAccount,
        intermediaryName: response.receivingBankDetailsIso.intermediaryName,
        intermediaryAddress: {
          department: "",
          streetName: "",
          buildingNumber: "",
          buildingName: "",
          floor: "",
          room: "",
          postCode: "",
          townName: response.receivingBankDetailsIso.intermediaryAddress.townName,
          townLocationName: "",
          districtName: "",
          countrySubDivision: response.receivingBankDetailsIso.intermediaryAddress.countrySubDivision,
          country: "",
          concatenatedAddress: ""
        },
        recBankPhone: "",
        intermediaryPhone: ""
      },
      receivingBankAba: response.receivingBankAba,
      abaMessageFields: {
        errorList: response.abaMessageFields.errorList,
        warningList: response.abaMessageFields.warningList,
        atsSystemErrors: response.abaMessageFields.atsSystemErrors,
      },
      detailsCallSucceeded: true,
      detailsCallFailed: false,
      loading: false,
      error: '',
      hasError: false,
      isIrsAba: response.isIrsAba
    };
  }),
  on(StandingAuthWireActions.wireDetailsCallFailed, (state, err) => {
    return {
      ...state,
      detailsCallSucceeded: false,
      detailsCallFailed: true,
      loading: false,
      error: err.message,
      hasError: true,
    };
  }),
  on(StandingAuthWireActions.loadWiresReviewPageWithoutVerifyCall, (state) => {
    return {
      ...state,
      loading: false,
      verifyCallFinished: true,
    };
  }),
  on(TransactionFormActions.callWiresVerifyV3, (state) => {
    return {
      ...state,
      verifyV3CallFinished: false,
    };
  }),
  on(StandingAuthWireActions.verifyV3CallSuccessful, (state, {response, inrReleaseFlowFromTable}) => {
    const fedTax = TaxAmountAndPercentageFormatter(
      response.transactionDetails.fedTax
    );
    const stateTax = TaxAmountAndPercentageFormatter(
      response.transactionDetails.stateTax
    );

    return {
      ...state,
      loading: false,
      verifyCallFinished: true,
      verifyV3CallFinished: true,
      wireFee: response.transactionDetails.wireFee,
      clientAuthorizationNeeded: response.uiFields.isClientAuthorizationNeeded,
      warningList: response.uiFields.warningsList,
      warningsList: response.uiFields.warningsList,
      eauthAccess: response.uiFields.eAuthAccess,
      eAuthModel: {
        ...response.eAuthModel,
        custAcctAuthorizationsList: {
          ...response.eAuthModel?.custAcctAuthorizationsList,
          eAuthCustomerList:
            response.eAuthModel?.custAcctAuthorizationsList?.eAuthCustomerList.map(
              (customer) => {
                const mappedCustomer = new EAuthModelCustomer(customer);
                mappedCustomer.isCustomerEAuthEligible = customer.eauthInd;
                return mappedCustomer;
              }
            ) ?? [],
        },
      },
      toDetails: response.toDetails,
      stateTaxAmount: stateTax.amount,
      fedTaxAmount: fedTax.amount,
      stateTaxPercent: stateTax.percentage,
      fedTaxPercent: fedTax.percentage,
      stateHasTaxes: response?.iraFields?.canDisplayStateTax ?? false,
      distributionReasonDescription:
        response.transactionDetails.distributionReason,
      wireAmount: response.transactionDetails.wireAmount,
      withdrawalAmount: response.transactionDetails.withdrawalAmount,
      caseId: (response.wireAuthResponse?.canRelease && inrReleaseFlowFromTable) ? state.caseId : response.transactionDetails.caseId,
      caseKey: (response.wireAuthResponse?.canRelease && inrReleaseFlowFromTable) ? state.caseKey : response.uiFields.caseKey,
      requestedDate: response.transactionDetails.requestDate,
      authResponse: response?.wireAuthResponse,
      attestationSubmittedBy: response.transactionDetails.attestationSubmittedBy,
      revalidation: response.revalidation,
      isIrsAba: state.isIrsAba,
      taxRemittance: response.taxRemittance,
    };
  }),
  on(StandingAuthWireActions.verifyV3CallFailed, (state, err) => {
    return {
      ...state,
      loading: false,
      error: err.message,
      hasError: true,
    };
  }),
  on(StandingAuthWireActions.acknowledgeCallV3Successful, (state, response) => {
    return {
      ...state,
      withholdFedTax: response.transactionDetails?.isWithholdFederalTaxes ?
        response.transactionDetails.isWithholdFederalTaxes?.toLowerCase() === 'yes' : false,
      withholdStateTax: response.transactionDetails?.isWithholdStateTaxes ?
        response.transactionDetails.isWithholdStateTaxes?.toLowerCase() === 'yes' : false,
      pendReasons: response.transactionDetails?.pendingReasons,
      transferId: `${response.fromDetails.subAccount}-${response.uiFields.cashieringRequestId}-${response.uiFields.cashieringRequestSecondId}`,
      requestedDate: response.transactionDetails?.requestDate,
    };
  }),
  on(StandingAuthReviewPageActions.clearAttentionMessage, (state, _) => {
    return {
      ...state,
      warningsList: [],
    };
  }),
  on(
    StandingAuthWireActions.callWiresVerifyV3,
    StandingAuthReviewPageActions.editClicked,
    (state, _) => {
      return {
        ...state,
        verifyCallFinished: false,
        verifyV3CallFinished: false,
      };
    }
  ),
  on(StandingAuthFormActions.editLoadComplete, (state) => {
    return {
      ...state,
      inputCallV3Finished: true,
      standingAuthorizationsCallFinished: true,
    };
  }),
  on(AccountInfoActions.loadAccountInfoSuccess, (state, info) => {
    return {
      ...state,
      eAuthModel: {
        ...state.eAuthModel,
        custAcctAuthorizationsList: {
          ...state.eAuthModel.custAcctAuthorizationsList,
          eAuthCustomerList: UpdateEauthCustomers(
            state.eAuthModel.custAcctAuthorizationsList.eAuthCustomerList,
            info
          ),
        },
      },
    };
  }),
  on(InitReleaseActions.initReleaseByDraftIdSuccessful, (state, { response, isSloa }) => {
    if (!isSloa || response.transactionType !== 'wire') return state;
    let draftObject = response.draftObject;
    return {
      ...state,
      authResponse: {
        ...state.authResponse,
        draftId: response.draftId,
      },
      receivingAccountHolder: {
        accountHolderName1: draftObject.beneName1 ?? '',
        accountHolderName2: draftObject.beneName2 ?? '',
        accountHolderAddress1: draftObject.beneAddress1 ?? '',
        accountHolderAddress2: draftObject.beneAddress2 ?? '', 
        countryCode: draftObject.beneCountry ?? '',
      },
      isFedWire: draftObject.withholdTaxes?.toString() === yesNo.yes,
      hasCustodianRole: !!draftObject.hasCustodianRole,
      fedTaxPercent: `${draftObject.fedTaxAmount.toString()}%`,
      stateTaxPercent: `${draftObject.stateTaxAmount.toString()}%`,
      toDetails: {
        ...state.toDetails,
        beneficiaryCountry: draftObject.beneCountry ?? ''
      },
      caseKey: response.draftObject.aceKey ?? '',
      caseId: response.draftObject.aceCaseId ?? '',
      isIrsAba: response.draftObject.isIrsAba ?? response.draftObject.IsIrsAba ?? false,
      taxRemittance: response.draftObject.taxRemittance ?? response.draftObject.TaxRemittance ?? {
        taxId: '',
        taxMonthCode: '',
        taxTypeCode: '',
        taxYear: '',
        additionalInfo: ''
      },
    }
  })
);

function UpdateEauthCustomers(
  eAuthCustomerList: EAuthModelCustomer[],
  info: AccountInfoResponse
): EAuthModelCustomer[] {
  let list: EAuthModelCustomer[] = [];
  eAuthCustomerList.forEach((item) => {
    let update = info.eauthorization.customers.find((customer) => {
      return customer.customerId === item.customerId;
    });
    if (update) {
      let result: EAuthModelCustomer = {
        isAccountWebEnabled: update.isAccountWebEnabled,
        customerWebEnrolled: "false",
        customerId: update.customerId,
        isCustomerWebEnrolled: update.isCustomerWebEnrolled,
        emailId: update.emailId,
        firstName: update.firstName,
        lastName: update.lastName,
        loginIdEnrollStatus: update.loginIdEnrollmentStatus,
        isDisplayAllowed: update.displayIndicator,
        isCustomerEAuthEligible: item.isCustomerEAuthEligible,
        organizationName: update.organizationName,
        eauthInd: item.eauthInd,
        typeCode: update.typeCode,
        customerRestrictionReason: item.customerRestrictionReason,
        accountRoles: update.accountRoles,
        eligibility: item.eligibility,
      };
      list.push(result);
    } else {
      list.push(item);
    }
  });
  return list;
}
